import * as React from 'react';

function SvgInfo(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 16.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm0 1.5a8 8 0 100-16 8 8 0 000 16z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 14.25a.75.75 0 01-.75-.75V10a.75.75 0 011.5 0v3.5a.75.75 0 01-.75.75z"
        fill={props.color}
      />
      <circle cx={10} cy={7} r={1} transform="rotate(-180 10 7)" fill={props.color} />
    </svg>
  );
}

export default SvgInfo;
